export default __webpack_public_path__ + "static/media/xenia.0c773d7e.webp";